<template>
    <div class="quality">
      <div class="quality-report-content">
        <div class="look-nav">
          <div class="look-nav-left">
            <div class="handle-wrapper" @click="backPath">
              <div class="icon-font">&#xe612;</div>
              <a>返回</a>
            </div>
          </div>
          <div class="look-nav-center">{{title}}</div>
          <div class="look-nav-right">
            <div class="handle-wrapper" @click="handleData" v-if="!inputValue.auditTime">
              <div class="icon-font">&#xe678;</div>
              <a>提交</a>
            </div>
          </div>
        </div>
        <div class="report-card-content" v-if="loading">
          <div class="loading-data">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
        </div>
        <div class="report-card-content" v-if="!loading">
          <div class="report-card-content-top">
            <div class="top-msg-left">
              <div class="top-msg-left-t">
                <div class="input-contain">
                  <div class="input-title" style="padding-left: 0.83vw">物料代码：</div>
                  <div class="input-wrapper" style="padding: 0.63vw">
                    <div class="popover" style="text-align: left" v-if="inputValue.materialCode.length < 18">
                      {{inputValue.materialCode}}
                    </div>
                    <div class="detail-item" style="width: 100%;display: block" v-if="inputValue.materialCode.length >= 18">
                      <el-popover
                        placement="top"
                        title=""
                        trigger="hover"
                        :content="inputValue.materialCode">
                        <div class="popover" slot="reference">{{inputValue.materialCode}}</div>
                      </el-popover>
                    </div>
                  </div>
                </div>
                <div class="input-contain">
                  <div class="input-title">烟叶简称：</div>
                  <div class="input-wrapper">
                    <label>
                      <input disabled="true" v-model="inputValue.materialName"/>
                    </label>
                  </div>
                </div>
              </div>
              <div class="top-msg-left-b">
                <div class="input-contain">
                  <div class="input-title">不合格项目：</div>
                  <div class="input-wrapper" style="flex: 1">
                    <input disabled="true" v-model="inputValue.unqualifiedProject"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="top-msg-right">
              <div class="top-msg-left-t">
                <div class="input-contain">
                  <div class="input-title">仓库位置：</div>
                  <div class="input-wrapper">
                    <input disabled="true" v-model="inputValue.siteName"/>
                  </div>
                </div>
                <div class="input-contain">
                  <div class="input-title">质检日期：</div>
                  <div class="input-wrapper" style="margin-right: 0">
                    <input disabled="true" v-model="inputValue.testingDate"/>
                  </div>
                </div>
              </div>
              <div class="top-msg-left-b">
                <div class="input-contain">
                  <div class="input-title" style="padding-left: 0.83vw">负责人：</div>
                  <div class="input-wrapper" style="flex: 1;margin-right: 0;display: flex;justify-content: flex-start;align-items: center;padding: 0 0.63vw">
                    <span style="color: #00d2ff;margin-right: 0.5vw" v-for="(data,index) in inputValue.principalList" :key="index">{{data.userName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="report-card-content-bottom">
            <div class="add-wrapper">
              <div class="input-title" style="padding-left: 1.73vw">审核人：</div>
              <div class="add-content">
                <div class="add-info" v-for="(data,index) in addData" :key="index">
                  {{data.userName}}（{{data.deptName || '--'}}）
                  <div class="icon-font close-icon" @click="deleteAddData(data.userId)">&#xe6f3;</div>
                </div>
                <div class="icon-font add-icon" @click="showAlert">&#xe605;</div>
              </div>
            </div>
            <div class="text-area-wrapper" style="margin-top: 1vw;margin-bottom: 1vw">
              <div class="text-area-title" style="padding-left: 0.83vw">审核意见：</div>
              <textarea rows="3" class="text-area-input" v-model="inputValue.auditorOpinion"></textarea>
            </div>
            <div class="input-contain" v-if="inputValue.auditTime">
              <div class="input-title" style="padding-left: 0.83vw">审核日期：</div>
              <div class="input-wrapper">
                <input disabled="true" v-model="inputValue.auditTime"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="alert-box" v-if="show">
          <div class="alert-add-content">
            <div class="alert-content-title">添加审核人</div>
            <div class="alert-content-msg">
              <DropDownInput type="1" :items="custodianValue" content="" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
            </div>
            <div class="alert-content-btn">
              <div class="btn-cancel button" @click="cancelAdd">取消</div>
              <div class="btn-confirm button" @click="submitAdd">添加</div>
            </div>
          </div>
        </div>
      </transition>
      <img class="quality-icon" src="../../../assets/content-box.png"/>
    </div>
</template>

<script>
import {reportQualityTesting, updateReportQualityTesting} from '../../../api/maintain'
import {changeTime} from '../../../tools/methods'
import {userList} from '../../../api/system'
import DropDownInput from '../../../components/DropDownInput.vue'
export default {
  name: 'ReportCard',
  components: { DropDownInput },
  data () {
    return {
      loading: true,
      userId: '',
      userName: '',
      deptName: '',
      custodianValue: [],
      title: null,
      show: false,
      addData: [],
      inputValue: {
        id: '',
        materialCode: '',
        materialName: '',
        siteName: '',
        testingDate: '',
        unqualifiedProject: '',
        principalList: '',
        auditorIdList: [],
        auditorOpinion: '',
        auditTime: ''
      }
    }
  },
  created () {
    let type = parseInt(this.$route.query.qcType)
    if (type === 1) {
      this.title = '入库质检报告单'
    } else if (type === 2) {
      this.title = '出库质检报告单'
    } else if (type === 3) {
      this.title = '在库质检报告单'
    } else {
      this.title = '质检历史记录报告单'
    }
    this.getData()
  },
  methods: {
    getData: function () {
      let id = parseInt(this.$route.query.id)
      reportQualityTesting({id: id}).then(res => {
        console.log(res)
        let arr = []
        this.addData = res.data.auditorList || []
        res.data.auditorList && res.data.auditorList.map(item => {
          arr.push(item.userId)
        })
        this.inputValue = {
          id: res.data.id,
          materialCode: res.data.materialCode,
          materialName: res.data.materialName,
          siteName: res.data.siteName,
          testingDate: changeTime(res.data.testingDate),
          unqualifiedProject: res.data.unqualifiedProject,
          principalList: res.data.principalList || [],
          auditorIdList: arr,
          auditorOpinion: res.data.auditorOpinion,
          auditTime: res.data.auditTime
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    showInfo: function (data) {
      console.log(data)
      this.userId = data.id
      this.userName = data.name
      this.deptName = data.deptName
    },
    sendValue: function (value) {
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        console.log(res)
        this.custodianValue = res.data.rows
        this.show = true
      }).catch(err => {
        console.log(err)
      })
    },
    backPath: function () {
      this.$router.go(-1)
    },
    cancelAdd: function () {
      this.show = false
      this.name = ''
      this.section = ''
    },
    submitAdd: function () {
      if (this.userId !== '') {
        let canAdd = true
        this.addData.map(item => {
          if (item.userId === this.userId) {
            canAdd = false
          }
        })
        if (canAdd) {
          this.show = false
          this.addData.push({userId: this.userId, userName: this.userName, deptName: this.deptName})
          this.userId = ''
          this.userName = ''
          this.deptName = ''
          console.log(this.addData)
        } else {
          this.$message({
            message: '该人员已经添加!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
        }
      } else {
        this.$message({
          message: '请选择要添加的人员!',
          type: 'success',
          center: 'true',
          duration: '1000'
        })
      }
    },
    showAlert: function () {
      this.handleSearchValue()
    },
    deleteAddData: function (id) {
      let addData = []
      this.addData.map((data, index) => {
        if (data.userId !== id) {
          addData.push(data)
        }
      })
      this.addData = addData
      this.$message({
        message: '删除成功!',
        type: 'success',
        center: 'true',
        duration: '1000'
      })
    },
    handleData: function () {
      console.log(this.inputValue)
      let arr = []
      console.log(this.addData)
      if (this.addData.length > 0) {
        this.addData.map(item => {
          arr.push(item.userId)
        })
        this.inputValue.auditorIdList = arr
      }
      if (this.inputValue.auditorIdList.length > 0) {
        let body = {
          id: this.inputValue.id,
          auditorIdList: arr,
          auditorOpinion: this.inputValue.auditorOpinion
        }
        updateReportQualityTesting(body).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.getData()
          } else {
            this.$message({
              message: res.message,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$message({
          message: '请选择审核人！',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    }
  }
}
</script>

<style scoped>
@import "Quality.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/quality/ReportCard.vue